<ion-header>
  <ion-toolbar class="or-bg-gradient or-d-flex or-h-56-px">
    <div class="or-align-items-center or-d-flex or-justify-content-between">
      <div class="or-min-w-32-px">
        @if (showBackArrow()) {
          <img (click)="goBack()" src="assets/icons/back-arrow-icon.svg" class="or-cursor-pointer" />
        }
      </div>

      <div class="or-color-white or-head-md text-no-wrap">{{ title() }}</div>

      <div class="or-align-content-center or-d-flex or-min-w-36-px">
        @if (showDots()) {
          <or-icon (click)="dotsClicked()" name="dots-vertical" size="m" class="or-px-12-px or-color-white" />
        }
        @if (showRandomize() || showRankQAIcon()) {
          <ion-buttons>
            @if (showRandomize()) {
              <ion-button (click)="randomizeClicked()">
                <or-icon name="randomize" size="m" class="or-color-white" />
              </ion-button>
            }

            @if (showRankQAIcon()) {
              <ion-button (click)="showRankQA()">
                <or-icon name="faq" size="m" class="or-color-white" />
              </ion-button>
            }
          </ion-buttons>
        }
      </div>
    </div>
  </ion-toolbar>
</ion-header>
@if (extended()) {
  <div class="or-bg-gradient or-h-36-px margin-top--1-px"></div>
}
